import React, { useState } from 'react'
import { Modal, Button, Radio, message } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import { RegionModalWrapper } from './style'
import { putExchange } from '../../common/fetch';
import { WHITE_SET_SERVER_REGION_ICON, FLAG_SINGAPORE_ICON, SET_SERVER_REGION_ICON, FLAG_FR_ICON } from '../../config/media';

const RegionModal = ({ visible, onCancel, exchange, getExchange }) => {

    const [step, setStep] = useState('')
    const [selectedRegion, setSelctedRegion] = useState('');

    const renderFooterBtn = () => {
        return (
            <RegionModalWrapper>
                <div className='footer-btn'>
                    <Button onClick={handleBack} className='mr-1' type='primary'>Back</Button>
                    <Button onClick={handleNext} disabled={step === 1 && selectedRegion === '' ? true : false} type='primary'>{getBtnLabel()}</Button>
                </div>
            </RegionModalWrapper>
        )
    }

    const getBtnLabel = () => {
        if (step === '') {
            return 'I understand, proceed'
        } else if (step === 1) {
            return 'Proceed'
        } else {
            return 'Set server region'
        }
    }

    const onHandleRegion = () => {
        putExchange({ region: selectedRegion, id: exchange.id })
            .then(res => {
                getExchange()
                onCancel(setStep)
            })

            .catch(err =>  message.error(err && err.data && err.data.message))
    }

    const handleNext = () => {
        if (step === '') {
            setStep(1)
        } else if (step === 1) {
            setStep(2)
        } else if (step === 2) {
            onHandleRegion()
        }
    }

    const handleBack = () => {
        if (step === '') {
            onCancel(setStep)
        } else if (step === 1) {
            setStep('')
        } else if (step === 2) {
            setStep(1)
        }
    }

    const renderModalContent = () => {
        switch (step) {
            case 1:
                return (
                    <RegionModalWrapper>
                        <img
                            src={SET_SERVER_REGION_ICON}
                            alt='set-server-icon'
                            className='cloud-icon-normal mr-2 placeholder-icon'
                        />
                        <div className='step-1-wrapper'>
                            <h2>Set server region</h2>
                            <p>Select your exchange's server region below:</p>
                            <Radio.Group onChange={(e) => setSelctedRegion(e.target.value)} value={selectedRegion}>
                                <Radio value={'SG'}>
                                    <img
                                        src={FLAG_SINGAPORE_ICON}
                                        alt='flag-singapore'
                                        className='flag-icon'
                                    />
                                    Singapore
                                </Radio>
                                <Radio value={'FR'}>
                                    <img
                                        src={FLAG_FR_ICON}
                                        alt='flag-fr'
                                        className='flag-icon'
                                    />
                                    France </Radio>
                            </Radio.Group>
                            {
                                selectedRegion !== '' ?
                                    <div className='warning-text'>
                                        <p><InfoCircleFilled /></p>
                                        <p>Once live, the server location cannot be easily changed. Please choose carefully.</p>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </RegionModalWrapper>
                )
            case 2:
                return (
                    <RegionModalWrapper>
                        <div className='step-2-wrapper'>
                            <h2>Check and confirm</h2>
                            <span>Select your exchange's server region below:</span>
                            <p>Please carefully check and confirm that the server region you've selected for your cloud crypto cloud exchange is correct.</p>
                            <div className='location-box-container'>
                                <h2>Location :</h2>
                                <p>{
                                    selectedRegion === 'SG' ?
                                        <div className='d-flex'>
                                            <img
                                                src={FLAG_SINGAPORE_ICON}
                                                alt='flag-singapore'
                                                className='flag-icon'
                                            />
                                            Singapore
                                        </div>
                                        : <div className='d-flex'>
                                            <img
                                                src={FLAG_FR_ICON}
                                                alt='flag-france'
                                                className='flag-icon'
                                            />
                                            France
                                        </div>
                                }</p>
                                <span className='float-label'>Your server's region</span>
                            </div>
                        </div>

                    </RegionModalWrapper>
                )
            default:
                return (
                    <RegionModalWrapper>
                        <div>
                            <img
                                src={WHITE_SET_SERVER_REGION_ICON}
                                alt='white-server-icon'
                                className='cloud-icon-normal mr-2'
                            />
                            <h2 >Set server region</h2>
                            <div>
                                <p>
                                    Please note that once your exchange goes live, it may be difficult and costly to change the server region you've set.
                                </p>
                                <p>
                                    Are you sure you want to proceed with your current server region choice?
                                </p>
                            </div>
                        </div>

                    </RegionModalWrapper>
                )
        }
    }


    return (
        <Modal
            visible={visible}
            onCancel={() => onCancel(setStep)}
            footer={null}
            width='400px'
        >
            {renderModalContent()}
            {renderFooterBtn()}

        </Modal>

    )
}

export default RegionModal